import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch, Link, withRouter } from 'react-router-dom';
import IENotSupportedPage from './IENotSupportedPage';
import Start from './Start';
import Devices from './Devices';
import Result from './Result';
import PrivacyPolicy from './PrivacyPolicy';
import InfoPopUp from './InfoPopUp';
import PropTypes from 'prop-types';
import { withStyles, MuiThemeProvider } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import { createMuiTheme } from '@material-ui/core/styles';
import crypto from 'crypto';
import styles from './styles';
import logo from './Logo_RZ_CMYK_iQ_IMAGE_Tag.png';

const customTheme = createMuiTheme({
  shape: { borderRadius: 0 },
  palette: {
    type: 'light',
    primary: { main: '#46388A' },
    background: { paper: '#fff', default: '#fff' },
  },
  overrides: {
    MuiInputLabel: {
      root: {
        color: '#fff',
      },
    },
  },
});

class ScrollRestorerBase extends Component {
  componentDidMount() {
    this.reset();
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.location.pathname !== prevProps.location.pathname ||
      this.props.location.search !== prevProps.location.search ||
      this.props.location.hash !== prevProps.location.hash
    ) {
      this.reset();
    }
  }
  reset() {
    const grid = document.getElementById('appGrid');
    if (grid) grid.scrollTop = 0;
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
  render() {
    return null;
  }
}
const ScrollRestorer = withRouter(ScrollRestorerBase);

class App extends Component {
  constructor() {
    super();
    this.state = {
      archiveTime: [
        { id: 1, value: '1', text: '1 year' },
        { id: 2, value: '5', text: '5 years' },
        { id: 3, value: '10', text: '10 years' },
        { id: 4, value: '15', text: '15 years' },
        { id: 5, value: '20', text: '20 years' },
        { id: 6, value: '25', text: '25 years' },
      ],
      selectedArchiveTime: '1',
      selectedInstitution: 'University or Large Hospital',
      selectedRegion: 'Europe, North America, Japan, Australia and Oceania',
      selectedDevices: [],
      calculation: 0,
      client: 'client_min',
      server: 'server_M',
      session: '',
      showPrivacyPolicy: false,
      isEDGE: false,
      showInfoDialog: false,
      activeStep: 0,
      shareableLink: '',
      isMobile: window.innerWidth <= 600,
    };
  }

  isVetInstitution = (institution) => {
    return institution === 'Small VET Clinic' || institution === 'Large VET Clinic';
  };

  removeMammographyForVet = (institution, devices) => {
    if (!this.isVetInstitution(institution)) {
      return devices;
    }

    return devices.filter(device => device.name !== 'MG');
  };

  handleResize = () => {
    const isMobile = window.innerWidth <= 600;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  };

  componentDidMount() {
    const isIE = /*@cc_on!@*/ false || !!document.documentMode;
    const isEdge = !isIE && !!window.StyleMedia;
    this.setState({ isEDGE: isEdge });

    const params = new URLSearchParams(window.location.search);
    let dataParam = params.get('data');
    if (!dataParam && window.location.hash) {
      const hash = window.location.hash;
      const qIndex = hash.indexOf('?');
      if (qIndex !== -1) {
        const hashParams = new URLSearchParams(hash.substring(qIndex));
        dataParam = hashParams.get('data');
      }
    }
    if (dataParam) {
      try {
        const decoded = JSON.parse(atob(decodeURIComponent(dataParam)));
        const decodedInstitution = decoded.ins || this.state.selectedInstitution;
        const decodedDevices = this.removeMammographyForVet(
          decodedInstitution,
          decoded.dev || this.state.selectedDevices
        );

        this.setState({
          selectedInstitution: decodedInstitution,
          selectedRegion: decoded.reg || this.state.selectedRegion,
          selectedDevices: decodedDevices,
          selectedArchiveTime: decoded.arch || this.state.selectedArchiveTime,
          calculation: decoded.calc || 0,
          server: decoded.srv || this.state.server,
          client: decoded.cli || this.state.client,
          session: decoded.ses || this.state.session,
        }, () => this.Calculate());
      } catch (error) {
        console.error('Error decoding shareable link data', error);
      }
    }
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  generateSessionNr = () => {
    const SessionNr = 'id_' + crypto.randomBytes(10).toString('hex');
    this.setState({ session: SessionNr });
    return SessionNr;
  };

  setUserData = (sessionID) => {
    if ((sessionID === 'home' || sessionID === '') && this.state.session === '') {
      this.generateSessionNr();
    } else if (
      sessionID !== undefined &&
      sessionID !== '' &&
      sessionID !== 'home' &&
      sessionID !== 'result' &&
      sessionID !== 'devices'
    ) {
      this.setState({ session: sessionID });
    }
  };

  Calculate = () => {
    if (this.state.selectedDevices.length !== 0) {
      const calculation = this.state.selectedDevices
        .map(
          (dev) =>
            (dev.studies_per_day * dev.size_per_study * 365 * this.state.selectedArchiveTime) /
            1000000
        )
        .reduce((acc, cur) => acc + cur, 0);
      this.SelectRecommendation(calculation);
      this.setState({ calculation: Math.round(calculation * 100) / 100 });
    } else {
      this.setState({ calculation: 0 });
    }
  };

  SelectRecommendation = (calcResult) => {
    if (calcResult <= 10) {
      this.setState({ client: 'client_min', server: 'server_M' });
    } else if (calcResult <= 15) {
      this.setState({ client: 'client_med', server: 'server_L' });
    } else {
      this.setState({ client: 'client_max', server: 'server_XL' });
    }
  };

  changeInstitution = (institution) => {
    this.setState(
      prevState => ({
        selectedInstitution: institution,
        selectedDevices: this.removeMammographyForVet(institution, prevState.selectedDevices),
      }),
      () => this.Calculate()
    );
  };

  changeRegion = (region) => {
    this.setState({ selectedRegion: region });
  };
  changeArchiveTime = (archiveTime) => {
    this.setState({ selectedArchiveTime: archiveTime }, () => this.Calculate());
  };

  changeDevices = (device) => {
    if (this.isVetInstitution(this.state.selectedInstitution) && device.name === 'MG') {
      return;
    }

    this.setState({ selectedDevices: [...this.state.selectedDevices, device] }, () =>
      this.Calculate()
    );
  };
  removeDevice = (device) => {
    this.setState(
      (prev) => ({ selectedDevices: prev.selectedDevices.filter((dev) => dev !== device) }),
      () => this.Calculate()
    );
  };

  getYear = () => new Date().getFullYear();

  openPrivacyPolicy = () => {
    this.setState({ showPrivacyPolicy: true });
  };
  closePrivacyPolicy = () => {
    this.setState({ showPrivacyPolicy: false });
  };

  openInfoDialog = () => {
    this.setState({ showInfoDialog: true });
  };
  closeInfoDialog = () => {
    this.setState({ showInfoDialog: false });
  };

  setActiveStep = (step) => {
    this.setState({ activeStep: step });
  };

  handleNext = () => {
    if (this.state.activeStep < 2) {
      this.setActiveStep(this.state.activeStep + 1);
    }
  };
  handleBack = () => {
    if (this.state.activeStep > 0) {
      this.setActiveStep(this.state.activeStep - 1);
    }
  };

  getNextLink = () => {
    if (this.state.activeStep === 0) return '/devices/';
    if (this.state.activeStep === 1) return '/result/';
    return '/result/';
  };
  getBackLink = () => {
    if (this.state.activeStep === 1) return '/';
    if (this.state.activeStep === 2) return '/devices/';
    return '/';
  };

  getShareableLink = () => {
    const {
      selectedInstitution,
      selectedRegion,
      selectedDevices,
      selectedArchiveTime,
      calculation,
      server,
      client,
      session,
    } = this.state;
    let sessionValue = session;
    if (selectedRegion === 'Europe, North America, Japan, Australia and Oceania') {
      sessionValue = 'anon';
    }

    const data = {
      dest: 'result',
      ins: selectedInstitution,
      reg: selectedRegion,
      dev: this.removeMammographyForVet(selectedInstitution, selectedDevices),
      arch: selectedArchiveTime,
      calc: calculation,
      srv: server,
      cli: client,
      ses: sessionValue,
    };
    const encodedData = encodeURIComponent(btoa(JSON.stringify(data)));
    let baseUrl = 'https://pacscalculator.com/#/result/';
    return `${baseUrl}?data=${encodedData}`;
  };

  updateShareableLink = () => {
    const newLink = this.getShareableLink();
    this.setState({ shareableLink: newLink });
  };

  render() {
    const { classes } = this.props;
    const isMobile = this.state.isMobile;
    const isIE = /*@cc_on!@*/ false || !!document.documentMode;
    if (isIE) {
      return <IENotSupportedPage />;
    } else {
      return (
        <Grid item xs={12} className={classes.grid} id="appGrid" style={isMobile ? { width: '100vw', minWidth: '0' } : {}}>
          <div className={classes.appContainer} style={isMobile ? { width: '100vw', minWidth: '0', boxSizing: 'border-box', overflowX: 'hidden' } : {}}>
            <Router>
              <MuiThemeProvider theme={customTheme}>
                <AppBar className={classes.appHeader} id="appHeader" position="static"
                  style={isMobile
                    ? {
                        minHeight: '46px',
                        width: '100vw',
                        padding: '6px 0 6px 0',
                        boxSizing: 'border-box',
                        backgroundColor: '#FFFFFF',
                        color: '#0F145C'
                      }
                    : {}
                  }
                >
                  <div
                    id="appHeaderInner"
                    style={
                      isMobile
                        ? {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            width: '100%',
                            padding: '0 16px',
                            position: 'relative',
                          }
                        : {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            position: 'relative',
                          }
                    }
                  >
                    <img
                      id="appLogo"
                      src={logo}
                      alt="Company logo"
                      style={
                        isMobile
                          ? {
                              height: '30px',
                              position: 'static',
                              marginRight: 0,
                              marginLeft: '10px',
                              objectFit: 'contain',
                              flexShrink: 0,
                            }
                          : {
                              height: '30px',
                              position: 'absolute',
                              left: '20px',
                              marginLeft: '10px',
                              objectFit: 'contain',
                            }
                      }
                    />
                    {isMobile && <div style={{ width: 24, minWidth: 12 }} />}
                    <span
                      id="appHeaderTitle"
                      style={
                        isMobile
                          ? {
                              fontWeight: 'bold',
                              fontSize: window.innerWidth <= 400 ? '12px' : '14px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              maxWidth: '70vw',
                              flexShrink: 1,
                            }
                          : { fontWeight: 'bold' }
                      }
                    >
                      PACS Sizing Calculator
                    </span>
                  </div>
                </AppBar>

                <InfoPopUp openDialog={this.state.showInfoDialog} changeDialogState={this.closeInfoDialog} />
                <div
                  className={classes.contentWrapper}
                  style={
                    isMobile
                      ? {
                          backgroundColor: '#F8F8FA',
                          width: '100vw',
                          minWidth: '0',
                          padding: 0,
                          overflowX: 'hidden',
                        }
                      : { backgroundColor: '#F8F8FA' }
                  }
                >
                  <Paper
                    className={classes.paper}
                    elevation={0}
                    style={isMobile ? { width: '100vw', minWidth: '0', boxSizing: 'border-box' } : {}}
                  >
                    <ScrollRestorer />

                    <Switch>
                      <Route
                        exact
                        path="/(home/|)"
                        render={(props) => (
                          <Start
                            {...props}
                            time={this.state.archiveTime}
                            changeInstitution={this.changeInstitution}
                            changeRegion={this.changeRegion}
                            changeTime={this.changeArchiveTime}
                            changeDialogState={this.openInfoDialog}
                            selectedIns={this.state.selectedInstitution}
                            selectedReg={this.state.selectedRegion}
                            selectedTime={this.state.selectedArchiveTime}
                            session={this.state.session}
                            getSessionID={this.setUserData}
                            isEDGE={this.state.isEDGE}
                          />
                        )}
                      />
                      <Route
                        exact
                        path="/devices/"
                        render={(props) => (
                          <Devices
                            {...props}
                            changeDevices={this.changeDevices}
                            getSelectedDevices={this.state.selectedDevices}
                            removeDevice={this.removeDevice}
                            selectedIns={this.state.selectedInstitution}
                            changeActiveStep={this.setActiveStep}
                          />
                        )}
                      />
                      <Route
                        exact
                        path="/result/"
                        render={(props) => (
                          <Result
                            {...props}
                            time={this.state.archiveTime}
                            changeTime={this.changeArchiveTime}
                            selectedTime={this.state.selectedArchiveTime}
                            getSelectedDevices={this.state.selectedDevices}
                            calc={this.state.calculation}
                            client={this.state.client}
                            session={this.state.session}
                            server={this.state.server}
                            isEDGE={this.state.isEDGE}
                            shareableLink={this.state.shareableLink}
                            updateShareableLink={this.updateShareableLink}
                            changeActiveStep={this.setActiveStep}
                            getSessionID={this.setUserData}
                          />
                        )}
                      />
                      <Route
                        path="/:id/"
                        render={(props) => (
                          <Start
                            {...props}
                            time={this.state.archiveTime}
                            changeInstitution={this.changeInstitution}
                            changeRegion={this.changeRegion}
                            changeTime={this.changeArchiveTime}
                            changeDialogState={this.openInfoDialog}
                            selectedIns={this.state.selectedInstitution}
                            selectedReg={this.state.selectedRegion}
                            selectedTime={this.state.selectedArchiveTime}
                            session={this.state.session}
                            getSessionID={this.setUserData}
                            isEDGE={this.state.isEDGE}
                          />
                        )}
                      />
                    </Switch>
                  </Paper>

                  <div className={classes.navContainer}
                    style={
                      isMobile
                        ? {
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            background: '#F8F8FA',
                            boxShadow: '0 -2px 12px rgba(50,50,100,0.08)',
                            padding: '8px 0 8px 0',
                            minHeight: '64px',
                            margin: 0,
                            width: '100vw',
                            zIndex: 1000
                          }
                        : {}
                    }
                  >
                    <div style={{ display: 'flex', justifyContent: 'center', gap: isMobile ? '16px' : '40px', marginBottom: '30px' }}>
                      {this.state.activeStep === 0 ? (
                        <Button
                          disabled
                          id="backButton"
                          className={classes.navButtonDisabled}
                        >
                          Back
                        </Button>
                      ) : (
                        <Link to={this.getBackLink()} style={{ textDecoration: 'none' }}>
                          <Button
                            id="backButton"
                            onClick={() => this.setActiveStep(this.state.activeStep - 1)}
                            className={classes.navButton}
                          >
                            Back
                          </Button>
                        </Link>
                      )}

                      {this.state.activeStep === 2 ? (
                        <Button
                          disabled
                          id="nextButton"
                          className={classes.navButtonDisabled}
                        >
                          Next
                        </Button>
                      ) : (
                        <Link to={this.getNextLink()} style={{ textDecoration: 'none' }}>
                          <Button
                            id="nextButton"
                            onClick={() => this.setActiveStep(this.state.activeStep + 1)}
                            className={classes.navButton}
                          >
                            Next
                          </Button>
                        </Link>
                      )}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', gap: isMobile ? '8px' : '14px' }}>
                      <Link to="/" onClick={() => this.setActiveStep(0)} style={{ textDecoration: 'none' }}>
                        <div
                          style={{
                            width: isMobile ? '10px' : '14px',
                            height: isMobile ? '10px' : '14px',
                            borderRadius: '50%',
                            backgroundColor: this.state.activeStep === 0 ? '#718FB7' : '#E0E0E0',
                          }}
                        />
                      </Link>
                      <Link
                        to="/devices/"
                        onClick={() => this.setActiveStep(1)}
                        style={{ textDecoration: 'none' }}
                      >
                        <div
                          style={{
                            width: isMobile ? '10px' : '14px',
                            height: isMobile ? '10px' : '14px',
                            borderRadius: '50%',
                            backgroundColor: this.state.activeStep === 1 ? '#718FB7' : '#E0E0E0',
                          }}
                        />
                      </Link>
                      <Link
                        to="/result/"
                        onClick={() => this.setActiveStep(2)}
                        style={{ textDecoration: 'none' }}
                      >
                        <div
                          style={{
                            width: isMobile ? '10px' : '14px',
                            height: isMobile ? '10px' : '14px',
                            borderRadius: '50%',
                            backgroundColor: this.state.activeStep === 2 ? '#718FB7' : '#E0E0E0',
                          }}
                        />
                      </Link>
                    </div>
                  </div>
                </div>

                {this.state.showPrivacyPolicy && (
                  <PrivacyPolicy
                    openDialog={this.state.showPrivacyPolicy}
                    changeDialogState={this.closePrivacyPolicy}
                  />
                )}
                <AppBar
                  className={classes.footer}
                  id="appFooter"
                  color="primary"
                  position="static"
                  style={isMobile ? { backgroundColor: '#46388A', width: '100vw', minWidth: '0', fontSize: '9pt', padding: '6px 0 6px 0' } : { backgroundColor: '#46388A' }}
                >
                  <div style={{ textAlign: 'center', width: '100%', paddingTop: '5px', paddingBottom: '5px' }}>
                    <div style={{ marginTop: '4px' }}>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.iq-image.com/"
                        className={classes.linkFooter}
                      >
                        IMAGE Information Systems Europe GmbH © 2003 - 2025
                      </a>
                    </div>
                  </div>
                </AppBar>
              </MuiThemeProvider>
            </Router>
          </div>
        </Grid>
      );
    }
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(App);


// WEBPACK FOOTER //
// ./src/App.js